// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__3E5hH","contactsBlock":"Footer_contactsBlock__Y6a0d","phone":"Footer_phone__pJkuV","place":"Footer_place__nuzFo"};